export default "__VITE_ASSET__04082b45__"